import { render, staticRenderFns } from "./ObiSurveyCard.vue?vue&type=template&id=453d4df3&scoped=true&"
import script from "./ObiSurveyCard.vue?vue&type=script&lang=js&"
export * from "./ObiSurveyCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiSurveyCard.vue?vue&type=style&index=0&id=453d4df3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d4df3",
  null
  
)

export default component.exports